import { create } from 'zustand';

export const useNotificationStore = create((set) => ({
  items: [],
  unreadCount: 0,

  addNotification: (payload) => {
    if (!payload?.id) return;
    set((s) => {
      if (s.items.some((i) => i.id === payload.id)) return s;
      const items = [{ ...payload, read: false }, ...s.items].slice(0, 100);
      return { items, unreadCount: items.filter((i) => !i.read).length };
    });
  },

  markAllRead: () =>
    set((s) => ({
      items: s.items.map((i) => ({ ...i, read: true })),
      unreadCount: 0,
    })),

  clear: () => set({ items: [], unreadCount: 0 }),
}));
